"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const callCenterCardInfo = (0, graphql_tag_1.default)`
  ${data_1.userMiniPopupSchemaFields}
  query callCenters_callCenter_card_info($cardId: Int!) {
    callCenters {
      callCenter {
        card {
          info(cardId: $cardId) {
            id
            status {
              type
              name
            }
            availableStatuses {
              type
              name
            }
            users {
              ...userMiniPopupSchemaFields
            }
            lastContact {
              date
              actor {
                ...userMiniPopupSchemaFields
              }
              channel
            }
            nextContact {
              date
            }
            callCenter {
              id
              type
              targetId
            }
          }
        }
      }
    }
  }
`;
exports.default = callCenterCardInfo;